import { tv } from 'tailwind-variants';

import { createEnumVariants } from '../../../utils/commonTailwindVariants.utils';
import { Size } from '../constants';

import { TabNavigatorType } from './TabNavigator.consts';

/**
 * Styles for the TabNavigator container
 */
export const tabNavigatorContainerStyles = tv({
  base: 'flex flex-row',
  variants: {
    orientation: createEnumVariants<typeof TabNavigatorType>({
      [TabNavigatorType.VERTICAL]: 'flex-shrink-0 flex-col gap-2',
      [TabNavigatorType.HORIZONTAL]: 'w-fit flex-row justify-center gap-8'
    }),
    tabSize: {
      [Size.SMALL]: '',
      [Size.LARGE]: ''
    }
  },
  compoundVariants: [
    {
      orientation: TabNavigatorType.HORIZONTAL,
      tabSize: Size.SMALL,
      className:
        'border-primary-dull w-full justify-start gap-4 border-b-[0.5px]'
    }
  ]
});

/**
 * Styles for the TabNavigatorOption container
 */
export const tabOptionContainerStyles = tv({
  base: 'flex',
  variants: {
    orientation: createEnumVariants<typeof TabNavigatorType>({
      [TabNavigatorType.VERTICAL]: 'py-1 pr-16',
      [TabNavigatorType.HORIZONTAL]: ''
    })
  }
});

/**
 * Styles for the TabNavigatorOption highlight container
 */
export const tabOptionHighlightStyles = tv({
  base: '',
  variants: {
    isSelected: {
      true: 'cursor-default',
      false: 'cursor-pointer'
    },
    tabSize: {
      [Size.SMALL]: '',
      [Size.LARGE]: ''
    }
  },
  compoundVariants: [
    {
      isSelected: true,
      tabSize: Size.LARGE,
      className: 'border-primary-bright border-b-2'
    },
    {
      isSelected: true,
      tabSize: Size.SMALL,
      className: 'border-b-1 border-white'
    },
    {
      isSelected: false,
      tabSize: Size.LARGE,
      className: 'opacity-60 hover:opacity-100 transition-opacity duration-200'
    }
  ]
});
